import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'

import { UserSearch } from '@/models/usersearch.model'

export default {
  components: {
    MenuComponent,
    BlocAuthenticated
  },
  data () {
    return {
      userListLocked: [],
      loading: false
    }
  },
  methods: {
    async getUserListLocked () {
      this.loading = true
      this.$store.dispatch('user/getUserListLocked').then(
        response => {
          this.userListLocked = response
          this.loading = false
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    },
    async unblockUser (userToUnblock) {
      this.loading = true
      this.$store.dispatch('user/unblockUser', userToUnblock.login).then(
        () => {
          this.userListLocked = []
          this.getUserListLocked()
          this.loading = false
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    },
    resetForm () {
      this.userSearch = new UserSearch()
    },
    format_date (value) {
      var moment = require('moment')
      moment.locale('fr')
      if (value) {
        return moment(value).format('DD MMM YYYY')
      }
    }
  },
  created () {
    if (!this.userListLocked.length) {
      this.getUserListLocked()
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Liste des utilisateurs verrouillés'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
